import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { HERO_IMAGE } from "@/data/site";

const input =
  "w-full rounded-xl border border-sand bg-ivory px-4 py-3.5 text-sm outline-none transition-colors placeholder:text-ink/40 focus:border-ink";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-ivory md:grid-cols-2" data-testid="login-page">
      <div className="relative hidden overflow-hidden md:block">
        <img src={HERO_IMAGE} alt="Noora" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/20" />
        <div className="absolute bottom-10 left-10 text-ivory">
          <p className="font-serif text-4xl font-light">Welcome back to Noora.</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-sm">
          <Link to="/" className="font-serif text-2xl tracking-[0.18em]">NOORA</Link>
          <h1 className="mt-10 font-serif text-4xl font-light tracking-tight text-ink">Log In</h1>
          <p className="mt-2 text-sm text-ink/60">Access your account, orders and wishlist.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <input required type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="login-email" />
            <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="login-password" />
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={busy} className="w-full rounded-full bg-ink py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ivory transition-colors hover:bg-gold disabled:opacity-60" data-testid="login-submit">
              {busy ? "Logging in…" : "Log In"}
            </button>
          </form>

          <p className="mt-6 text-sm text-ink/60">
            New to Noora?{" "}
            <Link to="/register" className="link-underline text-ink" data-testid="to-register">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
